import React from 'react';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';
import { CONTACT_CONFIG, getWhatsAppLink, isWhatsAppPlaceholder } from '../config/contact';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-12 border-t border-gray-800" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="grid md:grid-cols-4 gap-8" data-id="element-20">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-21">
            <div className="flex items-center gap-2 mb-4" data-id="element-22">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-23">
                <span className="text-white font-bold" data-id="element-24">iT</span>
              </div>
              <span className="font-bold text-xl text-white tracking-tight" data-id="element-25">
                iTranscorp
              </span>
            </div>
            <p className="text-sm text-gray-400 mb-4" data-id="element-26">
              Certified translation agency in Miami. Specialists in documents
              for USCIS and official processes.
            </p>
          </div>

          {/* Contact */}
          <div className="col-span-1 md:col-span-2" data-id="element-27">
            <h3 className="text-white font-bold mb-4" data-id="element-28">Contact</h3>
            <ul className="space-y-3" data-id="element-29">
              <li data-id="element-30">
                <a href={getWhatsAppLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-31">
                  <MessageCircle className="w-5 h-5 text-green-500" data-id="element-32" />
                  <span data-id="element-33">
                    WhatsApp:{' '}
                    {isWhatsAppPlaceholder ? '[WHATSAPP NUMBER HERE]' : CONTACT_CONFIG.WHATSAPP_NUMBER}
                  </span>
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-34">
                <Phone className="w-5 h-5 text-blue-500" data-id="element-35" />
                <span data-id="element-36">Phone: {CONTACT_CONFIG.PHONE}</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-37">
                <Mail className="w-5 h-5 text-blue-500" data-id="element-38" />
                <span data-id="element-39">Email: {CONTACT_CONFIG.EMAIL}</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-40">
                <MapPin className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" data-id="element-41" />
                <span data-id="element-42">{CONTACT_CONFIG.ADDRESS}</span>
              </li>
            </ul>
          </div>

          {/* Languages */}
          <div className="col-span-1" data-id="element-43">
            <h3 className="text-white font-bold mb-4" data-id="element-44">Main Languages</h3>
            <ul className="space-y-2 text-sm" data-id="element-45">
              <li data-id="element-46">Spanish ↔ English</li>
              <li data-id="element-47">Portuguese ↔ English</li>
              <li data-id="element-48">French ↔ English</li>
              <li data-id="element-49">Italian ↔ English</li>
              <li className="pt-2 text-gray-500 italic" data-id="element-50">
                + 50 additional languages
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-sm text-center text-gray-500" data-id="element-51">
          <p data-id="element-52">
            &copy; {new Date().getFullYear()} iTranscorp. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}